import { createContext, useContext } from 'react'

export const DeliveryContext = createContext(null)
export const useDeliveryContext = () => useContext(DeliveryContext)